var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-button',{attrs:{"secondary":"","text":_vm.$t('cancel')},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }